(() => {
  'use strict';
  let forwarding = false;

  function providerMounted(service) {
    if (service === 'rewards') {
      return Boolean(document.querySelector('#smile-ui-container iframe.smile-launcher-frame, #smile-ui-container iframe.smile-panel-frame'));
    }
    if (service === 'help') {
      return Boolean(document.querySelector('.rp-micro-app-dummy-icon-container, #richpanel_messenger_iframe'));
    }
    return false;
  }

  document.addEventListener('click', async (event) => {
    const link = event.target.closest?.('a[data-sb-service]');
    if (!link) return;

    const widgetHash = link.dataset.sbWidgetHash;
    const fallback = link.dataset.sbFallback;
    const plainClick = event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

    // Send modified clicks to a useful full page rather than an app-only hash.
    if (!plainClick) {
      if (widgetHash && fallback) link.setAttribute('href', fallback);
      return;
    }

    const drawer = link.closest('menu-drawer');
    if (!forwarding && drawer?.open && typeof drawer.hide === 'function') {
      event.preventDefault();
      event.stopImmediatePropagation();
      await drawer.hide();
      // The theme releases its focus trap in a timer after hiding the drawer.
      setTimeout(() => {
        forwarding = true;
        try { link.click(); } finally { forwarding = false; }
      }, 0);
      return;
    }

    // Explicit cart-to-Contact links have no widget hash and retain their destination.
    if (!widgetHash || !fallback) return;
    const destination = providerMounted(link.dataset.sbService) ? widgetHash : fallback;
    link.setAttribute('href', destination);
  }, true);
})();
